<div class="bottom-sheet product-card" id="sheet">
    <span class="cursor-pointer">
        <mat-icon class="float-right " (click)="close()">close</mat-icon>
    </span>
    <div class="product-row ">
        <img [src]="imageBaseUrl + addItam?.cartData?.image" class="product-img">
        <div class="product-info">
            <h3>{{addItam?.cartData?.product_name | titlecase}}</h3>
            <p class="color">Colour: <b>{{addItam?.cartData?.color | titlecase}}</b>           
            </p>
            <div class="link-details"> <a  (click)="showDetails(addItam?.cartData)">See all item details</a></div>
        </div>
    </div>
    <hr>
    <div class="variants-container" *ngIf="addItam?.sizes.length > 0">
        <div class="selcte-size-color-text">{{ getVariantLabel(addItam) }} : </div>
        <div class="size-options">
            <div *ngFor="let size of addItam?.sizes" class="variant-inline-size" (click)="onSizeSelect(size)"
                [ngClass]="{ 'selected': size.size === selectedSize }">
                <div>{{size.size}}</div>
            </div>
        </div>
    </div>

    <p class="recommend" *ngIf="showItemSize">
        <b>{{selectedSize}}</b> is your Selected {{ getVariantLabel(addItam) }} <mat-icon class="green-icon">check</mat-icon>
    </p>
    <div class="price-section">
        <span class="deal">Limited time deal</span>
        <div class="price-row">
            <span class="price">₹ {{addItam?.cartData?.price}}</span>
            <span class="mrp">M.R.P ₹ {{addItam?.cartData?.mrp}}</span>
            <span class="off">Save ₹ {{addItam?.cartData?.product_discount}}</span>
        </div>
        <p class="delivery">FREE of delivery By <b>Ruralx</b></p>
    </div>
        <div class="mrp-content mb-2">In Stocks :
          <span
                        [ngClass]="{'in-stock': selectedSizeStock !== null && selectedSizeStock >= 5,'limited-stock': selectedSizeStock !== null && selectedSizeStock > 0 && selectedSizeStock < 5,'out-stock': selectedSizeStock === 0}">
                        {{selectedSizeStock !== null && selectedSizeStock >= 5 ? 'In Stock': selectedSizeStock !== null && selectedSizeStock > 0 && selectedSizeStock <
                            5 ? 'Limited Stock' : 'Out of Stock' }} </span>
        </div>

    <div class="text-center">
    <button class="btn btn-warning btn-md mb-2 mr-2 btn-align-buy btn-design"
        [disabled]="isSelectedSizeOutOfStock" (click)="addCart($event,addItam)"><i class="fa fa-shopping-cart"> </i>
        ADD TO CART
    </button>
</div>
</div>